import React, { useState, useCallback, useMemo } from 'react';
import { Styled } from './styled.es.js';
import { TableHead } from './TableHead.es.js';
import { TableBody } from './TableBody.es.js';
import { TableFoot } from './TableFoot.es.js';
import { TableRow } from './TableRow.es.js';
import { TableCell } from './TableCell.es.js';
import { TableContext } from './TableContext.es.js';
import { TABLE_EVENTS } from './Table.constants.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Table = (_a) => {
  var _b = _a, {
    children,
    listenKeyEvents = false,
    stickyHeader = false,
    isRuled = false,
    onRowChange,
    focusedRowIndex,
    setFocusedRowIndex
  } = _b, props = __objRest(_b, [
    "children",
    "listenKeyEvents",
    "stickyHeader",
    "isRuled",
    "onRowChange",
    "focusedRowIndex",
    "setFocusedRowIndex"
  ]);
  const [internalFocusedRowIndex, setInternalFocusedRowIndex] = useState(-1);
  const [tableBodyNode, setBodyNode] = useState();
  const dispatchRowChangedEvent = useCallback((newRowIndex, didKeyboardNav) => {
    tableBodyNode == null ? void 0 : tableBodyNode.dispatchEvent(new CustomEvent(TABLE_EVENTS.ROW_CHANGED, {
      detail: {
        newRowIndex,
        didKeyboardNav
      }
    }));
  }, [tableBodyNode]);
  const tableContext = useMemo(() => {
    const useFocusedRowIndexStateOverrides = setFocusedRowIndex && focusedRowIndex !== void 0;
    return {
      dispatchRowChangedEvent,
      focusedRowIndex: useFocusedRowIndexStateOverrides ? focusedRowIndex : internalFocusedRowIndex,
      isRuled,
      listenKeyEvents,
      onRowChange,
      setBodyNode,
      setFocusedRowIndex: useFocusedRowIndexStateOverrides ? setFocusedRowIndex : setInternalFocusedRowIndex,
      stickyHeader,
      tableBodyNode
    };
  }, [
    dispatchRowChangedEvent,
    internalFocusedRowIndex,
    setInternalFocusedRowIndex,
    focusedRowIndex,
    setFocusedRowIndex,
    isRuled,
    listenKeyEvents,
    onRowChange,
    setBodyNode,
    stickyHeader,
    tableBodyNode
  ]);
  return /* @__PURE__ */ React.createElement(TableContext.Provider, {
    value: tableContext
  }, /* @__PURE__ */ React.createElement(Styled.Table, __spreadValues({}, props), children));
};
Table.displayName = "Table";
Table.Head = TableHead;
Table.Body = TableBody;
Table.Foot = TableFoot;
Table.Row = TableRow;
Table.Cell = TableCell;
const DoczTableProps = () => /* @__PURE__ */ React.createElement(React.Fragment, null);

export { DoczTableProps, Table };
//# sourceMappingURL=Table.es.js.map
